import Vue from 'vue';

Vue.filter('asPrice', (price) => `${String(price).replace('.', ',')} zł`);
